import React, { useState, useEffect } from "react";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { User } from "models/user/user";
import { UserChangePassword } from "api/user";
import LoadingComponent from "common/components/loader";
interface Props {
  user: User;
}

const ChangePasswordComponent: React.FC<Props> = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const formik = useFormik({
    initialValues: {
      username: user.username ?? "",
      currentPassword: "",
      password: "",
      passwordConfirm: "",
    },
    validationSchema: Yup.object({
      //email: Yup.string().email("Invalid email address").required("Email is required"),
      username: Yup.string().required("Username is required"),
      currentPassword: Yup.string().required("Password is required"),
      password: Yup.string().required("Password is required").min(6, "Password must be at least 6 characters"),
      passwordConfirm: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values) => {
      // Handle form submission logic here (e.g., send reset link)

      try {
        setError("");
        setSuccess("");
        setLoading(true);
        const res = await UserChangePassword({
          username: values.username ?? "",
          currentPassword: values.currentPassword,
          newPassword: values.password ?? "",
        });

        if (!(res?.status?.isError ?? false) && (res?.data?.status ?? false)) {
          setSuccess("success");
        } else {
          setError("error");
        }
        setLoading(false);
      } catch (error) {
        setError("error");
        setLoading(false);
      }
    },
  });

  return (
    <React.Fragment>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <h5 className="mb-4">Change Password</h5>

        <div className="card">
          <div className="card-body">
            <form className="form-horizontal" onSubmit={formik.handleSubmit}>
              <label className="inline-block mb-2 text-base font-medium">User Name</label>
              <input
                name="username"
                className={`form-input 
                            focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 
                            disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 
                            disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 
                            placeholder:text-slate-400 dark:placeholder:text-zink-200
                            ${
                              formik.touched.username && formik.errors.username
                                ? "border-red-500"
                                : "border-slate-200 dark:border-zink-500"
                            }`}
                placeholder="Username"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.username || ""}
                disabled={true}
              />
              {formik.touched.username && formik.errors.username ? (
                <div className="mt-1 text-sm text-red-500">{formik.errors.username}</div>
              ) : null}

              <label className="inline-block mb-2 text-base font-medium">Current Password</label>
              <input
                name="currentPassword"
                className={`form-input 
                            focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 
                            disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 
                            disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 
                            placeholder:text-slate-400 dark:placeholder:text-zink-200
                            ${
                              formik.touched.currentPassword && formik.errors.currentPassword
                                ? "border-red-500"
                                : "border-slate-200 dark:border-zink-500"
                            }`}
                placeholder="Current Password"
                type="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.currentPassword || ""}
              />
              {formik.touched.currentPassword && formik.errors.currentPassword ? (
                <div className="mt-1 text-sm text-red-500">{formik.errors.currentPassword}</div>
              ) : null}

              <label className="inline-block mb-2 text-base font-medium">Password</label>
              <input
                name="password"
                className={`form-input 
                            focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 
                            disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 
                            disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 
                            placeholder:text-slate-400 dark:placeholder:text-zink-200
                            ${
                              formik.touched.password && formik.errors.password
                                ? "border-red-500"
                                : "border-slate-200 dark:border-zink-500"
                            }`}
                placeholder="Password"
                type="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password || ""}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="mt-1 text-sm text-red-500">{formik.errors.password}</div>
              ) : null}

              <label className="inline-block mb-2 text-base font-medium">Confirm Password</label>
              <input
                name="passwordConfirm"
                className={`form-input 
                            focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 
                            disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 
                            disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 
                            placeholder:text-slate-400 dark:placeholder:text-zink-200
                            ${
                              formik.touched.passwordConfirm && formik.errors.passwordConfirm
                                ? "border-red-500"
                                : "border-slate-200 dark:border-zink-500"
                            }`}
                placeholder="Confirm Password"
                type="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.passwordConfirm || ""}
              />
              {formik.touched.passwordConfirm && formik.errors.passwordConfirm ? (
                <div className="mt-1 text-sm text-red-500">{formik.errors.passwordConfirm}</div>
              ) : null}

              <div className="text-center mt-4">
                <button
                  type="submit"
                  className="px-2 py-1.5 text-xs text-white btn bg-red-500 hover:text-white hover:bg-red-600 focus:text-white focus:bg-red-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:ring active:ring-custom-100 dark:bg-red-500/20 dark:text-red-500 dark:hover:bg-red-500 dark:hover:text-white dark:focus:bg-red-500 dark:focus:text-white dark:active:bg-red-500 dark:active:text-white dark:ring-red-400/20"
                >
                  Update
                </button>
              </div>
            </form>
            {success && (
              <div
                className="px-4 py-3 mt-3 text-sm text-green-500 border border-green-200 rounded-md
                 bg-green-50 dark:bg-green-400/20 dark:border-green-500/50
                  text-center"
                id="successAlert"
              >
                <b>Success! </b> Your password has been changed now.
              </div>
            )}
            {error && (
              <div
                className="px-4 py-3 mt-3 text-sm text-red-500 border border-red-200 
                rounded-md bg-red-50 dark:bg-red-400/20 
                dark:border-red-500/50
                text-center
                "
                id="successAlert"
              >
                Oops! Something went wrong while attempting to reset password reset. Please try again later or contact
                support for assistance.
              </div>
            )}
            {loading && <LoadingComponent></LoadingComponent>}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChangePasswordComponent;
